<app-breadcrumb
  [title]="'Cambiar Contraseña'"
  [breadcrumb]="'Cambiar Contraseña'"
></app-breadcrumb>
<!-- personal deatail section start -->
<section class="contact-page register-page">
  <div class="container">
    <div class="row">
      <div class="col-sm-12">
        <h3>Cambiar Contraseña</h3>
        <form [formGroup]="usuarioForm" class="theme-form">
          <div class="row">
            <div class="col-md-6">
              <label for="name">Contraseña Actual</label>
              <div class="cont-icon-eye">
                <input
                  [type]="hidePass ? 'password' : 'text'"
                  autocomplete="new-password"
                  style="width: 100% !important"
                  pattern="^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[a-zA-Z]).{6,}$"
                  formControlName="PasswordActual"
                  required="required"
                  class="form-control"
                />
                <span
                  class="toggle-password"
                  [ngClass]="{
                    'show-password': !hidePass,
                    'hide-password': hidePass
                  }"
                  (click)="togglePassword('password')"
                ></span>
              </div>
            </div>
            <div class="col-md-6"></div>
          </div>
          <div class="row" formGroupName="passwordGroup">
            <div class="col-md-6">
              <label for="email">Nueva Contraseña</label>
              <div class="cont-icon-eye">
                <input
                  (keyup)="onPasswordInput($event)"
                  [type]="hideNewPass ? 'password' : 'text'"
                  autocomplete="new-password"
                  style="width: 100% !important"
                  pattern="^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[a-zA-Z]).{6,}$"
                  formControlName="PasswordNuevo"
                  required="required"
                  class="form-control"
                />
                <span
                  class="toggle-password"
                  [ngClass]="{
                    'show-password': !hideNewPass,
                    'hide-password': hideNewPass
                  }"
                  (click)="togglePassword('newPass')"
                ></span>
              </div>
            </div>
            <div class="col-md-6">
              <label for="review">Confirmar Contraseña</label>
              <div class="cont-icon-eye">
                <input
                  matInput
                  [type]="hideConfirm ? 'password' : 'text'"
                  formControlName="ConfirmarPassword"
                  autocomplete="new-password"
                  required="required"
                  class="form-control input-danger"
                />
                <span
                  class="toggle-password"
                  [ngClass]="{
                    'show-password': !hideConfirm,
                    'hide-password': hideConfirm
                  }"
                  (click)="togglePassword('confirm')"
                ></span>
              </div>
              <span
                class="text-danger"
                *ngIf="usuarioForm.get('passwordGroup').hasError('match')"
              >
                Las contraseñas no coinciden.
              </span>
            </div>
            <div class="col-md-6">
              <p class="mb-0">
                <i
                  class="fa fa-check-circle"
                  [ngClass]="{ checked: minCaracteres && maxCaracteres }"
                  aria-hidden="true"
                ></i>
                La contraseña debe tener más de 6 caracteres y menos de 16.
              </p>
              <p class="mb-0">
                <i
                  class="fa fa-check-circle"
                  [ngClass]="{ checked: hasMayus && hasMinus }"
                  aria-hidden="true"
                ></i>
                Al menos una mayúscula y minúsculas.
              </p>
              <p class="mb-0">
                <i
                  class="fa fa-check-circle"
                  [ngClass]="{ checked: espCaracter }"
                  aria-hidden="true"
                ></i>
                Un caracter no alfanumérico (ejemplo: #?!&).
              </p>
              <p class="mb-0">
                <i
                  class="fa fa-check-circle"
                  [ngClass]="{ checked: hasNumber }"
                  aria-hidden="true"
                ></i>
                Un número.
              </p>
            </div>
          </div>
          <div class="col-md-12 mt-3">
            <button class="btn btn-sm btn-solid" (click)="cambiarContrasena()">
              Guardar
            </button>
          </div>
        </form>
        <br />
      </div>
    </div>
  </div>
</section>
<!-- Section ends -->
